module.exports = __webpack_public_path__ + "static/media/zu-ZA.382e77d7.md";